import { tv } from 'tailwind-variants';

const rangeInputStyles = tv({
    slots: {
        wrapper: `
      iris:flex
      iris:flex-col
      iris:gap-(--comp-space-gap-input)
    `,
        row: `
      iris:order-0
      iris:grid
      iris:grid-cols-[1fr_auto_1fr]
      iris:items-center
      iris:gap-(--comp-space-gap-slider-input)
    `,
        sep: `
      iris:[grid-column:2]
      iris:[grid-row:1]
      iris:text-(--comp-color-content-input-helper-default)
    `,
        helper: `
      iris:order-2
      iris:overflow-hidden
      iris:font-(family-name:--comp-type-font-input-helper)
      iris:text-(length:--comp-type-size-input-helper)
      iris:leading-(--comp-type-leading-input-helper)
      iris:font-(--comp-type-weight-input-helper)!
      iris:tracking-(--comp-type-tracking-input-helper)
      iris:break-words
      iris:whitespace-normal                        
      iris:text-(--comp-color-content-input-helper-default)
    `,
        inlineMessage: `
      iris:order-1
      iris:flex
      iris:overflow-hidden
      iris:break-words                        
      iris:whitespace-normal
      `,
        error: `
      iris:text-(length:--comp-type-size-input-helper)
      iris:text-(--comp-color-content-input-helper-error)
      iris:hover:text-(--comp-color-content-input-helper-error)
    `,
    },
    variants: {
        error: {
            true: {},
            false: {},
        },
        inverse: {
            true: {
                helper: "iris:text-(--comp-color-content-input-helper-inverse-default)",
                error: `
          iris:text-(--comp-color-content-input-label-inverse-error)
          iris:hover:text-(--comp-color-content-input-label-inverse-error)
        `,
            },
        },
        disabled: {
            true: {
                error: `
          iris:cursor-not-allowed
          iris:opacity-(--sem-opacity-interactive-disabled)
        `,
                helper: `
          iris:cursor-not-allowed
          iris:opacity-(--sem-opacity-interactive-disabled)
        `,
            },
        },
    },
    defaultVariants: {
        error: false,
        inverse: false,
        disabled: false,
    },
});

export { rangeInputStyles as default, rangeInputStyles };
